import React, {PureComponent} from 'react';
import bytes from 'bytes';
import intl from 'react-intl-universal';

import {ImageresizeApi} from 'modules';
import {BadgeAd, BannerAd, Box, ClipboardInput, Loader, ResponsiveTable, ShareBox, ContextMenu, ContextMenuItem, ContextMenuTrigger} from 'components';
import {removeExtension, simplifyUrl} from 'utils';
import withPageTracking from 'hoc/withPageTracking';
// import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

import CheckCircleIcon from 'assets/icons/check-circle.svg';

import styles from './styles';

class ImageDownload extends PureComponent {
  state = {
    saveToWebState: null
  };
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  saveToWeb = () => {
    const {result} = this.props;
    const imageId = result.imageId;

    this.setState({
      saveToWebState: 'loading'
    });

    ImageresizeApi.updateImageMetadata(imageId, {
      expirationDateTime: 'never'
    })
      .then(() => this.setState({
        saveToWebState: 'success'
      }))
      .catch(() => this.setState({
        saveToWebState: 'error'
      }));
  };

  getImageName({ imageType, originalImage }) {

    if (imageType) {
      return `${removeExtension(originalImage.name)}.${imageType}`;
    }

    return originalImage.name;
  }

  renderImageInfo() {
    const {result} = this.props;
    const columns = {
      fileName: {
        filter: simplifyUrl,
        grow: true,
        heading: intl.get('File Name')
      },
      originalSize: {
        heading: intl.get('Original Size'),
        width: '120px'
      },
      originalDimensions: {
        heading: intl.get('Original (px)'),
        width: '130px'
      },
      newSize: {
        bold: true,
        heading: intl.get('New Size'),
        width: '120px'
      },
      newDimensions: {
        bold: true,
        heading: intl.get('New (px)'),
        width: '130px'
      }
    };
    const rows = [{
      fileName: this.getImageName(result),
      originalSize: bytes(result.originalImage.contentLength),
      originalDimensions: `${result.originalImage.dimensions.width} x ${result.originalImage.dimensions.height}`,
      newSize: bytes(result.contentLength),
      newDimensions: `${result.dimensions.width} x ${result.dimensions.height}`
    }];

    return (
      <ResponsiveTable
        columns={ columns }
        rows={ rows }
        type="default"
      />
    );
  }

  renderSaveToWebSection() {
    const {saveToWebState} = this.state;
    const {result} = this.props;
    
    if (!saveToWebState) {
      return null;
    }

    if (saveToWebState === 'loading') {
      return <Loader text={intl.get('View.SavingMsg')} />;
    }

    if (saveToWebState === 'error') {
      return (
        <Box>
          {intl.get('Failed to save the image, please try again later.')}
        </Box>
      );
    }

    return (
      <Box className={styles.leftAlignText}>
        <h3 className={styles.verticalCenterChildren}>
          <CheckCircleIcon className={styles.rightMargin} height="32" width="32" />
          {intl.get('Image Saved Permanently')}
        </h3>
        <ClipboardInput
          label={intl.get('Image Link')}
          value={ `${ImageresizeApi.BASE_URL}/view/${result.imageId}` }
        />
        <ClipboardInput
          labelClass="text-danger"
          label={intl.get('View.DeleteLink')}
          hint={intl.get('View.DeleteHint')}
          value={ `${ImageresizeApi.BASE_URL}/del/${btoa(result.imageId)}` }
        />
      </Box>
    );
  }
  renderFCButton(type) {
    if(type === 'png') {
      return (
        <a
          target="_blank"
          className='button'
          href="https://www.freeconvert.com/to-jpg"
        >
          {intl.get('Convert to JPG')}
        </a>
        );
    } else {
      return (
        <a
          target="_blank"
          className='button'
          href="https://www.freeconvert.com/to-png"
        >
         {intl.get(' Convert to PNG')}
        </a>
        );
    }
  }
  render() {
    const {result} = this.props;
    const imageUrl = ImageresizeApi.getImageUrl(result.imageId);
    const downloadUrl = ImageresizeApi.getImageUrl(result.imageId, simplifyUrl(result.originalImage.name));
    const EditLink = '/edit/' + result.originalImage.imageId;
    return (
      <div className='sideBySide container'>
        <div className='maxWidthSection'>
          <h3 className={styles.verticalCenterChildren}>
            <CheckCircleIcon className={styles.rightMargin} height="32" width="32" />
            {intl.get('Save Your Image')}
          </h3>
          <ContextMenuTrigger id="img-menu">
              <img
                className={styles.previewImage}
                src={imageUrl}
                alt="Result"
              />
          </ContextMenuTrigger>

          <ContextMenu id="img-menu">
            <ContextMenuItem>
              {intl.get('ContextMenuItem')}
            </ContextMenuItem>
          </ContextMenu>
          <div className='section'>
            {this.renderImageInfo()}
            <p><b>{intl.get('Note:')} {intl.get('You can')} <a href={EditLink}>{intl.get('re-edit')}</a> {intl.get('this image.')}</b></p>
          </div>
          <div className='section'>
            <BannerAd />
            <div className={styles.saveButtons}>
              <div className='row'>
                <div className='col-4'>
                  <a
                    className='button'
                    href={downloadUrl}
                    target='_blank'
                  >
                    {intl.get('Download Image', {num: 0})}
                  </a>
                </div>
                {/* <div className='col-3 col-sm-6'>
                  <a
                    className='button'
                    onClick={this.saveToWeb}
                  >
                    {intl.get('Save to Web')}
                  </a>
                </div> */}
                <div className='col-4'>
                  {this.renderFCButton(result.imageType)}
                </div>
                <div className='col-4'>
                  <a
                    target="_blank"
                    className='button'
                    href="https://www.freeconvert.com/to-pdf"
                  >
                    {intl.get('Convert to PDF')}
                  </a>
                </div>
              </div>
            </div>
            {this.renderSaveToWebSection()}
            
            <ShareBox />
          </div>
        </div>
        <BadgeAd />

      </div>
    );
  }
}

export default withPageTracking(ImageDownload, '/single-results.html');



// WEBPACK FOOTER //
// ./src/containers/ImageResize/ImageDownload.jsx